'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _nuiIntl = require('@concur/nui-intl');

var _reactRouter = require('react-router');

var _utils = require('../utils');

!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require('./style/SearchBar.css') : void 0;

var _trackClick = require('../HOCs/trackClick');

var _trackClick2 = _interopRequireDefault(_trackClick);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var extractValue = function extractValue(cb, e) {
  cb(e.target.value);
};

var SearchBar = function (_Component) {
  _inherits(SearchBar, _Component);

  function SearchBar() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SearchBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SearchBar.__proto__ || Object.getPrototypeOf(SearchBar)).call.apply(_ref, [this].concat(args))), _this), _this.handleSearch = function (e) {
      e.preventDefault();
      if (!_this.props.search) {
        return;
      }
      document.title = _this.context.getTitle('Search: ' + _this.props.search);
      _this.props.router.push((0, _utils.getAppCenterPathName)(_this.props.location.pathname) + '/search/' + encodeURIComponent(_this.props.search));
      _this.props.filterApps();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SearchBar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          search = _props.search,
          onChange = _props.onChange,
          router = _props.router,
          location = _props.location,
          host = _props.host,
          formatter = _props.formatter;


      var TrackedButton = (0, _trackClick2.default)(_react2.default.createElement(
        'button',
        { id: 'ac-search-btn', className: 'btn btn-lg btn-default search-btn-spacing' },
        _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'Search' })
      ), 'CLICK', {
        context: router.location.pathname === '' + (0, _utils.getAppCenterPathName)(location.pathname) ? 'HOME' : 'LISTING_DETAILS',
        type: 'BUTTON',
        value: 'SEARCH',
        searchKeyword: search,
        domain: { host: host }
      });

      return _react2.default.createElement(
        'div',
        { className: 'search-bar-container' },
        _react2.default.createElement(
          'form',
          {
            onSubmit: this.handleSearch
          },
          _react2.default.createElement('input', {
            className: 'ac-search-bar form-control input-lg',
            placeholder: formatter.formattedMessage({ id: 'FindApps' }),
            value: search,
            type: 'text',
            onChange: extractValue.bind(undefined, onChange)
          }),
          _react2.default.createElement(TrackedButton, null)
        )
      );
    }
  }]);

  return SearchBar;
}(_react.Component);

SearchBar.propTypes = {
  search: _propTypes2.default.string.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  filterApps: _propTypes2.default.func.isRequired,
  router: _propTypes2.default.object.isRequired, // eslint-disable-line react/forbid-prop-types
  location: _propTypes2.default.object.isRequired, // eslint-disable-line react/forbid-prop-types
  host: _propTypes2.default.string,
  formatter: _propTypes2.default.object // eslint-disable-line react/forbid-prop-types
};

function mapStateToProps(state) {
  return {
    host: state.meta.host
  };
}

SearchBar.contextTypes = {
  getTitle: _propTypes2.default.func
};

exports.default = (0, _reactRouter.withRouter)((0, _nuiIntl.withFormatter)((0, _reactRedux.connect)(mapStateToProps, {})(SearchBar)));


//////////////////
// WEBPACK FOOTER
// ./lib/shared/SearchBar.js
// module id = 564
// module chunks = 0